import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { take, map } from 'rxjs/operators';
import { MemberFacade } from '@core/facades/member.facade';

export const memberGuard: CanActivateFn = () => {
  const memberFacade = inject(MemberFacade);

  return memberFacade.isMemberExisting$.pipe(
    take(1),
    map((isExisting) => {
      return isExisting;
    }),
  );
};
